import {
  Textarea,
  Text,
  TextareaProps,
  Box,
  Flex,
  Icon,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@chakra-ui/react'
import { useFormContext } from 'react-hook-form'
import InfoIcon from '@/public/assets/icons/info.svg'

export const VerifyFormTextarea = ({
  name,
  placeholder,
  label,
  description,
}: {
  name: string
  description?: string
  placeholder?: string
  label?: string
} & TextareaProps) => {
  const {
    register,
    formState: { errors },
  } = useFormContext()
  const error = errors[name]

  return (
    <Box mb={3}>
      <Flex alignItems={'center'} justifyContent={'space-between'}>
        {label && (
          <Text mb={1} fontSize={'sm'} fontWeight={700}>
            {label}
          </Text>
        )}
        {!!description && (
          <Popover placement={'top'}>
            <PopoverTrigger>
              <Icon cursor={'pointer'} color={'ninja.200'} as={InfoIcon} />
            </PopoverTrigger>
            <PopoverContent
              bg={'ninja.400'}
              p={2}
              border={'none'}
              rounded={'lg'}
              boxShadow={'0px 4px 32px 0px rgba(0, 0, 0, 0.24);'}
              maxW={'220px'}
              fontSize={'xs'}
              fontWeight={500}
              color={'ninja.100'}
              textAlign={'center'}
            >
              {description}
            </PopoverContent>
          </Popover>
        )}
      </Flex>

      <Textarea
        {...register(name)}
        p={4}
        bg={'ninja.500'}
        rounded={'2xl'}
        fontWeight={700}
        fontSize={'sm'}
        variant={'unstyled'}
        css={{
          '&::-webkit-scrollbar': {
            width: '4px',
            borderRadius: '6px',
          },
          '&::-webkit-scrollbar-track': {
            width: '6px',
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#1d1c49',
            borderRadius: '24px',
          },
        }}
        mr={1}
        rows={6}
        placeholder={placeholder}
        _placeholder={{
          color: 'ninja.300',
        }}
        _focus={{
          outline: 'transparent !important',
        }}
        _focusVisible={{
          outline: 'transparent !important',
        }}
        _active={{
          outline: 'transparent !important',
        }}
        outline={'none'}
        resize={'none'}
        border={'2px solid'}
        borderColor={!!error ? 'brand.error' : 'transparent'}
      />
      {!!error && (
        <Text lineHeight={1.1} px={3} mt={1} fontWeight={700} fontSize={'xs'} color={'brand.error'}>
          {error.message?.toString() || ''}
        </Text>
      )}
    </Box>
  )
}
